import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ActionDashboardPage" */
	'pages/rights/Action/ActionDashboardPage'));

export default [{ component, exact: true, path: '/actions/:actionId' }];